'use strict';

(function ($) {

	var mainHeader;
	mainHeader = $('header[role="banner"]');

	// Trigger the my reservations modal based on a given URL hash
	var hash, trigger, target, signIn, checkRates, adaSpan;
	// the url fragment to trigger the modal on
	trigger = 'myreservations';
	signIn = 'signin';
	checkRates = 'checkrates';
	// the modal we'll target
	target = $('#reservations-modal');
	// check to see if the url has a hash
	if (window.location.hash) {
		// the string to search for our fragment in (the url string)
		hash = window.location.hash;
		// check to see if the trigger exists in the hash
		if (hash.includes(trigger) || hash.includes(signIn)) {
			// open the modal
			target.modal('toggle');
		}

		if (hash.includes(checkRates)) {
			$('.check-rates').show();
		}
	}

	var screenWidth = window.innerWidth;

	var megaMenuTrigger = $('.menu-level-0 > li.menu-item--expanded');
	var headerClose = mainHeader.not(megaMenuTrigger);
	var topLevelMenuItem = $('.menu-level-0 > li.menu-item');

	headerClose.on('click', function () {
		if (screenWidth >= 1110) {
			clearScreen.dropDowns();
		}
	});

	megaMenuTrigger.children('span').attr('aria-expanded', 'false');
	megaMenuTrigger.on('click', function (event) {
		topLevelMenuItem.not(this).removeClass('open');
		topLevelMenuItem.removeClass('faded');
		adaSpan = $(this).children('span').eq(0); // the span clicked


		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$('.page-header').removeClass('focused');
			setAriaExpandedFalse($(this));
			topLevelMenuItem.removeClass('faded');
			adaSpan.attr('aria-expanded', 'false'); // show as toggled closed for ADA
		} else {
			$(this).addClass('open');
			$('.page-header').addClass('focused');
			setAriaExpandedTrue($(this));
			topLevelMenuItem.not(this).addClass('faded');
			adaSpan.attr('aria-expanded', 'true'); // show as toggled open for ADA
		}

		var fadedMenuItems = $('li.menu-item--expanded.faded').children('button').attr('aria-expanded', 'false');

		clearScreen.booking();
		clearScreen.secondaryMenus();
		event.stopPropagation();

		// if(pageHeader.length) {
		//   $(pageHeader).toggleClass('focused');
		// }
	});

	var setAriaExpandedFalse = function setAriaExpandedFalse(jquerythis) {
		if (jquerythis.children('button').attr('aria-expanded') === 'true') {
			jquerythis.children('button').attr('aria-expanded', 'false');
		}
	};

	var setAriaExpandedTrue = function setAriaExpandedTrue(jquerythis) {
		if (jquerythis.children('button').attr('aria-expanded') === 'false') {
			jquerythis.children('button').attr('aria-expanded', 'true');
		}
	};

	var pageHeader = $("header.page-header");

	$('.js-mega-close').on('click', function () {
		pageHeader.removeClass('focused');
		clearScreen.dropDowns();
		var expandableMenuBtnsArray = $('li.menu-item--expanded').children('button');
		expandableMenuBtnsArray.attr('aria-expanded', 'false');
		return false;
	});

	var propertyMenu = $("nav.property");
	var nodeContent = $(".node__content");
	var memberSection = $(".members");
	var blogPage = $(".c-post-full__post");
	var membersPage = $('section.members');
	var membersRegisterPage = $('.path-member .register-account');

	var mobileMatch = window.matchMedia('(max-width: 1110px)');
	var mobileMenuWrapper = $('.navigation-mobile-wrapper');
	var mobileMenu = $('nav.menu--main--mobile');
	var propertyMenuMobile = $("nav.property-nav-mobile");
	var translateMobile = $("nav.mobile-language-menu");

	$('.menu-toggle').on('click', function () {
		if (!$(this).hasClass('is-active')) {
			$(this).attr('aria-expanded', 'true').addClass('is-active');
			$('body').addClass('scroll-lock');
		} else {
			$(this).attr('aria-expanded', 'false').removeClass('is-active');
			$('body').removeClass('scroll-lock');
		}

		mobileMenuWrapper.toggleClass('show');

		$(mainHeader).toggleClass('mobile-open');

		if (mainHeader.hasClass('focused')) {
			$(mainHeader).removeClass('focused');
		}

		clearScreen.booking();
		clearScreen.secondaryMenus();
	});

	// new mobile behaviors
	$('ul.menu > .menu-item--expanded', mobileMenu).on('click', function (e) {
		if ($(this).parents('.sub-menu').length <= 0) {
			$(this).toggleClass('show');
		}
	});

	$('ul.menu > .menu-item--expanded', propertyMenuMobile).on('click', function (e) {
		if ($(this).parents('.sub-menu').length <= 0) {
			$(this).toggleClass('show');
		}
	});

	$('ul.menu > .menu-item--expanded', translateMobile).on('click', function (e) {
		if ($(this).parents('.sub-menu').length <= 0) {
			$(this).toggleClass('show');
		}
	});

	function staticHeader(staticHeader, noHero) {
		if (staticHeader.hasClass(noHero)) {
			$(pageHeader).toggleClass('staticHeader');
		}
	}

	staticHeader(nodeContent, 'no-hero');
	staticHeader(blogPage, 'no-hero');
	staticHeader(membersPage, 'no-hero');
	staticHeader(membersRegisterPage, 'no-hero');

	//   if( membersRegisterPage ) {
	// 	$('header.page-header').addClass('sticky');
	//   }

	$('.menu-item--expanded', '.sub-menu-level-1').on('click', function (e) {
		$(this).toggleClass('show');
		e.stopPropagation();
		return false;
	});

	$('.menu-item', '.sub-menu-level-2').on('click', function (e) {
		e.stopPropagation();
	});

	$('.mobile-secondary').on('click', '.menu-item', function () {
		$(this).siblings('.menu-item').removeClass('show');
	});
	//

	$('.btn--check-rates').on('click', function () {
		clearScreen.dropDowns();
		clearScreen.mobileMenu();
		clearScreen.secondaryMenus();
		if ($(window).width() <= 1110) {
			$('body').addClass('scroll-lock');
		} else {
			$('body').removeClass('scroll-lock');
		}
	});

	// Menu Secondary Nav New Translate.
	var translateMenuNew = $("nav.top-nav-translation");
	var translateMenuNewDropdown = $("nav.top-nav-translation .sub-menu");
	if (translateMenuNew.length) {
		translateMenuNew.on('click', function () {
			clearScreen.secondaryMenus('noLangMenu');

			translateMenuNewDropdown.toggle();
			$(this).toggleClass('show');

			translateMenuNew.attr('aria-expanded', function (index, attr) {
				return attr === 'false' ? 'true' : 'false';
			});

			translateMenuNewDropdown.attr('aria-hidden', function (index, attr) {
				return attr === 'true' ? 'false' : 'true';
			});
		});
	}

	// Menu Secondary New Property Nav.
	var propertyMenuNew = $("nav.top-nav-property");
	var propertyMenuNewDropdown = $("nav.top-nav-property .sub-menu");
	if (propertyMenuNew.length) {
		propertyMenuNew.on('click', function () {
			clearScreen.secondaryMenus();
			propertyMenuNewDropdown.toggle();
			$(this).toggleClass('show');
		});
	}
	var propertyMenuBtn = $("nav.top-nav-property .menu-item--expanded button");
	propertyMenuBtn.click(function () {
		if ($(this).attr('aria-expanded') === "true") {
			$(this).attr('aria-expanded', 'false');
		} else {
			$(this).attr('aria-expanded', 'true');
		}
	});

	// Secondary nav Call Us
	var callUsTrigger, callUsDropDown, callUsClose, crmTrigger, crmDropDown, crmClose, appDownloadTrigger, appDownloadDropDown;
	callUsTrigger = $('.secondary-navigation .call-menu');
	callUsDropDown = $('.secondary-navigation .call-menu .sub-menu');
	callUsClose = mainHeader.not(callUsTrigger);

	crmTrigger = $('.secondary-navigation .js-mission');
	crmDropDown = $('.secondary-navigation .mission-menu');
	crmClose = mainHeader.not(crmTrigger);

	appDownloadTrigger = $('.secondary-navigation .js-util-app-download');
	appDownloadDropDown = $('.secondary-navigation .js-app-download-menu');

	if (callUsTrigger.length) {
		callUsTrigger.on('click', function () {
			clearScreen.secondaryMenus("noCallMenu");
			// clearScreen.mobileMenu();
			callUsDropDown.toggle();
			$(this).toggleClass('show');
		});
	}

	if (crmTrigger.length) {
		crmTrigger.on('click', function () {
			clearScreen.secondaryMenus("noMissionMenu");
			crmDropDown.toggle();
			$(this).toggleClass('show');
		});
	}

	if (appDownloadTrigger.length) {
		appDownloadTrigger.on('click', function () {
			clearScreen.secondaryMenus("noAppDownloadMenu");
			appDownloadDropDown.toggleClass('app-download-menu-hidden');
			$(this).toggleClass('show');
		});
	}

	// Secondary nav dropdowns
	// var secondaryDropdownTrigger, secondaryDropDown, secondaryClose;
	// secondaryDropdownTrigger = $('.menu--secondary-nav > ul.menu > li.menu-item--expanded:not(".call")');
	// secondaryDropDown = $('.sub-menu', secondaryDropdownTrigger);
	// secondaryClose = mainHeader.not(secondaryDropdownTrigger);

	// if(secondaryDropdownTrigger.length) {
	// 	secondaryDropdownTrigger.on('click', function(){
	// 		console.log('dont do that');
	// 		secondaryDropDown.toggle();
	// 		if(screenWidth >= 768) {
	// 			clearScreen.all();
	// 		}
	// 	});
	// }

	$(document).on("click", function (event) {
		var $trigger = $(".js-secondary");
		if ($trigger !== event.target && !$trigger.has(event.target).length) {
			$trigger.find(".sub-menu").hide();
			$trigger.parent().removeClass('show');
			$trigger.removeClass('show');
		}
	});

	// This needs to be addressed. So so dirty.
	$("a[href$='/press-room']").addClass('menu-header');
	$("a[href$='/contact-us']").addClass('menu-header');

	// Moving the Call icon on mobile
	// var mobileMatch = window.matchMedia('(max-width: 768px)');
	var callUsMenuMobile = $('.menu--call-us > ul.menu');
	var callMenuItem = $('li.call');
	var callDropdown = $('li.call .sub-menu');
	var toggleCallAriaExpanded = function toggleCallAriaExpanded(inCallDropDown) {
		if (inCallDropDown.attr('style') === "display: block;") {
			inCallDropDown.siblings('button').attr('aria-expanded', 'true');
		} else {
			inCallDropDown.siblings('button').attr('aria-expanded', 'false');
		}
	};

	if (callMenuItem.length) {
		callMenuItem.on('click', function () {
			callDropdown.toggle();
			toggleCallAriaExpanded(callDropdown);
		});
	}

	if (mobileMatch.matches) {
		callUsMenuMobile.append(callMenuItem);
	}

	mobileMatch.addEventListener("change", function () {
		if (mobileMatch.matches) {
			callUsMenuMobile.append(callMenuItem);
		} else {
			$('.menu--secondary-nav > ul').append(callUsMenuMobile.find('.call'));
		}
	});

	$('.select2').on('click', function () {
		clearScreen.callUs();
	});

	function closeMegaMenuScrollDown() {
		var openedDesktopMegaMenus = $('li.menu-item--expanded.open');
		if (openedDesktopMegaMenus) {
			openedDesktopMegaMenus.removeClass('open');
		}
	}

	function determineMobileViewport() {
		if (window.innerWidth < 1110) {
			return true;
		}
		return false;
	}

	var lastScrollTop = 0;
	$(window).scroll(function (event) {
		var st = $(this).scrollTop();
		var openedMegaMenus = $('.menu-item--expanded.open');
		var isMobileViewport = determineMobileViewport();
		if (openedMegaMenus.length && isMobileViewport) {
			return;
		}

		if (st > lastScrollTop) {
			closeMegaMenuScrollDown();
		}
		lastScrollTop = st;
	});

	// moveOffers();
	// window.addEventListener("resize", moveOffers, false);
	//append language switcher
	// jQuery(window).on('load', function () {
	// 	if(window.innerWidth >= 768) {
	// 		jQuery('.language-switch').appendTo('.menu--secondary-nav');
	// 	}
	// });

	var missionHamburgerBtn = $('nav.menu--members-sf .nav-toggle');
	var missionNav = $('nav.menu--members-sf .subnav-stick ul.menu');
	var missionReturnLinks = $('nav.menu--members-sf .subnav-stick .return-link');
	missionHamburgerBtn.on('click', function () {
		missionNav.toggleClass('mobile-show');
		missionReturnLinks.toggleClass('mobile-show');
		missionHamburgerBtn.toggleClass('mobile-show');
	});

	$(window).on('resize', function () {
		var currentScreenWidth = window.innerWidth;
		if (currentScreenWidth >= 1280) {
			missionHamburgerBtn.removeClass('mobile-show');
			missionNav.removeClass('mobile-show');
			missionReturnLinks.removeClass('mobile-show');
		}
	});

	$(window).on('load', function (e) {
		setTimeout(function (e) {
			// Setting timeout to give the Google Translate library time to generate its markup before our custom code.
			var googleTranslateElem = $('#google_translate_element');
			// Transplanting Google Translate Element based on mobile or larger viewports
			var currentScreenWidth = window.innerWidth;
			if (googleTranslateElem && currentScreenWidth < 1110) {
				googleTranslateElem.appendTo('.navigation-mobile-wrapper');
				googleTranslateElem.addClass('mobile-language-selector');
				var languageSpan = document.createElement('span');
				languageSpan.textContent = "Language";
				googleTranslateElem.find('.goog-te-gadget').first().append(languageSpan);
			}

			// if (googleTranslateElem && currentScreenWidth >= 768) {
			// 	googleTranslateElem.appendTo('.secondary-navigation');
			// 	googleTranslateElem.removeClass('mobile-language-selector');
			// }

			// ADA stuff
			var generatedGoogleTranslateElem = $('.goog-te-gadget-simple');
			generatedGoogleTranslateElem.attr({
				'tabindex': 0,
				'role': 'button'
			});
			generatedGoogleTranslateElem.on('keydown', function (event) {
				if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
					event.target.click();
				}
			});
		}, 1000);
	});
})(jQuery);

(function ($, Drupal) {
	'use strict';

	Drupal.behaviors.resizeMobileMenu = {
		attach: function attach(context) {
			var mainHeader = $('header[role="banner"]');
			var mobileNavWrapper = $('.navigation-mobile-wrapper');

			//removing class on header that makes it white when mobile menu is open
			//added a debouncer to only fire function when user has stopped resizing
			var resizeTimer;

			$(window).on('resize', function (e) {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function () {
					if ($(window).width() >= 1110) {
						if (mainHeader.hasClass('mobile-open')) {
							mainHeader.removeClass('mobile-open');
						}
						if (mobileNavWrapper.hasClass('show')) {
							mobileNavWrapper.removeClass('show');
							$('hamburger').removeClass('is-active');
						}
					}
				}, 250);
			});
			mainHeader.removeClass('focused');
		}
	};
})(jQuery, Drupal);

(function ($, Drupal) {
	'use strict';

	Drupal.behaviors.closeAllMenus = {
		attach: function attach(context) {
			var closeAllonEsc = function closeAllonEsc(e) {
				if (e.keyCode === 27) {
					clearScreen.dropDowns();
					clearScreen.booking();
					clearScreen.mobileMenu();
					clearScreen.secondaryMenus();
					// clearScreen.propertySelector();

					// removeEventListener("keyup", closeAllonEsc);
				}
			};
			addEventListener("keyup", closeAllonEsc);
		}
	};
})(jQuery, Drupal);